// @flow
import { getListCookie, deleteCookie } from 'utils/cookies';
import { uuid } from 'utils/functional';
import { isBrowser } from 'utils/browser';
import type { Action } from '../actions/flashMessages';

// need unique ID for React list of messages (using index caused issues)
const getFlashMessageId = () => uuid() + new Date().getTime().toString(36);

export type State = $ReadOnlyArray<FlashMessageType>;

const getFlashMessages = (): State => {
  if (isBrowser()) {
    const messages = getListCookie('flashMessages');
    deleteCookie('flashMessages');
    return messages.map(message => ({ ...message, id: getFlashMessageId() }));
  }
  return [];
};

const initialState: State = getFlashMessages();

export default (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case 'PUSH_FLASH_MESSAGE':
      action.message.id = getFlashMessageId();
      return [...state, action.message];

    case 'REMOVE_FLASH_MESSAGE': {
      const toRemove = action.id;
      return state.filter(m => m.id !== toRemove);
    }

    case 'CLEAR_FLASH_MESSAGES':
      // remove all messages that aren't sticky
      return [...state.filter(m => m.sticky)];

    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
};
